import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { useEffect } from 'react';
import {
    getSubmission,
    getSubmissionsFetchError,
    getSubmissionsIsFetching,
} from '@selectors/submissions';
import { fetchSubmission } from '@actions/submissions';
import { Submission } from 'src/types/shared/Assessments';

const useSingleUserApplication = (id: number): Hook => {
    const dispatch = useDispatch();

    const application =
        useSelector((state: RootState) => getSubmission(state, +id)) ?? ({} as Submission);
    const isFetching = useSelector(getSubmissionsIsFetching);
    const fetchError = useSelector(getSubmissionsFetchError);

    useEffect(() => {
        dispatch(fetchSubmission(id));
    }, [dispatch, id]);

    return { application, isFetching, fetchError };
};

interface Hook {
    application: Submission;
    isFetching: boolean;
    fetchError: string | null;
}

export default useSingleUserApplication;
